<template lang="html">
  <div>
    <div
      v-if="isSupported"
      class="vue-audio-recorder"
      :class="{
        'active': isRecording,
        'paused': isPaused,
        'disabled': disabled
      }"

      @click="onClick"
    >
      <span></span>
    </div>
    <div v-if="!disabled">
      <span>{{ hint }}</span>
    </div>
  </div>
</template>

<script>
import RecorderMixin from './RecorderMixin'
import SafariRecorderMixin from './SafariRecorderMixin'

let mixins = [];

if (!window.MediaRecorder) {
  console.warn('Using Safari polyfill');
  mixins.push(SafariRecorderMixin)
} else {
  mixins.push(RecorderMixin)
}
// import ElementMixin from './ElementMixin'

const supportedTypes = [
  'audio/aac',
  'audio/ogg',
  'audio/wav',
  'audio/webm',
]

export default {
  name: 'VueRecordAudio',
  mixins: mixins,
  props: {
    mimeType: {
      type: String,
      default: 'audio/webm',
      validator: v => supportedTypes.includes(v)
    },
    mode: {
      type: String,
      default: 'press',
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      constraints: {
        audio: true,
        video: false
      },
      elapsed: 0,
      timer: null,
      isActive: false,
      isDisabled: true,
    }
  },
  computed: {
    hint: function() {
      if (this.isActive) {
        return 'Recording ' + this.pad(parseInt(this.elapsed / 60), 2) + ':' + this.pad(this.elapsed % 60, 2)
      } else {
        if (this.elapsed == 0) {
          return ''
        }
        return 'Recorded [' + this.pad(parseInt(this.elapsed / 60), 2) + ':' + this.pad(this.elapsed % 60, 2) + ']'
      }
    }
  },
  methods: {
    onClick() {
      if (this.disabled) {
        return
      }
      this.isActive = !this.isActive
      if (this.isActive) {
        this.startRecording()
      } else {
        this.stopRecording()
      }
    },
    stopRecording () {
      clearInterval(this.timer)
      this.timer = null
      return this.stop()
    },
    startRecording () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.elapsed = 0
      this.timer = setInterval(() => {
        this.elapsed++
      }, 1000);
      return this.start()
    },
    pad(value, size) {
      let s = value + ''
      while (s.length < size) {
        s = "0" + s
      }
      return s
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="scss">
  .vue-audio-recorder {
    position: relative;
    background-color: #FF0000;
    border-radius: 50%;
    width: 88px;
    height: 88px;
    display: inline-block;
    cursor: pointer;
    box-shadow: 0 0 0 0 rgba(232, 76, 61, 0.7);
    &:hover {
      background-color: #FF0000;
    }
    &.active {
      background-color: #ef5350;
      -webkit-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
      -moz-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
      animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
    }
    &.disabled {
      background-color: #979797;
    }
    &:before,
    &:after {
      content: '';
      position: absolute;
      background-color: #fff;
    }
    &:after {
      top: 30%;
      left: 43%;
      height: 15%;
      width: 14%;
      border-top-left-radius: 50%;
      border-top-right-radius: 50%;
    }
    &:before {
      top: 40%;
      left: 43%;
      height: 15%;
      width: 14%;
      border-bottom-left-radius: 50%;
      border-bottom-right-radius: 50%;
    }
    span {
      position: absolute;
      top: 50%;
      left: 36%;
      height: 24%;
      width: 28%;
      overflow: hidden;
      &:before,
      &:after {
        content: '';
        position: absolute;
        background-color: #fff;
      }
      &:before {
        bottom: 50%;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        border-radius: 50%;
        border: 0.125em solid #fff;
        background: none;
        left: 0;
      }
      &:after {
        top: 50%;
        left: 40%;
        width: 20%;
        height: 25%;
      }
    }
  }
  @keyframes pulse {
    to {
      box-shadow: 0 0 0 10px rgba(239, 83, 80, 0.1);
      background-color: #E53935;
      transform: scale(0.9);
    }
  }
</style>
